'use strict';

module.exports = require('./components/DocEditor/Block').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/Block.js
// module id = 1830
// module chunks = 0